import { Box, Text, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const TitleText = styled(Text)`
  white-space: nowrap;
`
export const ValueText = styled.p`
  font-size: 36px;
  color: ${(props) => props.theme.colors.grey_1};
`

export const CardBox = styled(Box)<{ url?: string }>`
  position: relative;
  transition: background-color 0.3s;

  ${({ url, theme }) =>
    url &&
    `
    &:hover {
      background-color: ${getThemeColor('grey_5', theme)};
    }
  `}
`

export const UrlIcon = styled(Box)`
  position: absolute;
  right: 16px;
  bottom: 16px;
`
